const offilneBooking = "จองผ่านหน้าร้าน"
const onlineBooking = "จองผ่านระบบ"

export const bookingType = { offilneBooking, onlineBooking }
export const bookingTypeArray = [offilneBooking, onlineBooking]

export default bookingType
